<template>
    <svg viewBox="0 0 24 24" :width="size" :height="size">
        <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.2" />
        <text
            x="12"
            y="15"
            text-anchor="middle"
            font-family="Roboto, '-apple-system', 'Helvetica Neue', Helvetica, Arial, sans-serif"
            font-weight="400"
            font-size="10"
            fill="currentColor"
        >M</text>
    </svg>
</template>

<script setup lang="ts">
interface Props {
    size?: number | string
}

withDefaults(defineProps<Props>(), {
    size: 36,
})
</script>
